import classNames from "classnames";

export const wrapper = classNames(
    // Mobile
    "mobile:flex-col",
    "mobile:py-8",
    // Tablet
    "tablet:flex-row",
    "tablet:pb-8",
    "tablet:py-0",
    // All
    "flex",
    "items-center",
    "justify-center",
)

export const icon = classNames(
    // Mobile
    "mobile:-top-10",
    "mobile:left-[40%]",
    // Tablet
    "tablet:top-4",
    "tablet:-left-8",
    // All
    "absolute",
    "w-[70px]"
)

export const borderBox = classNames(
    // Mobile
    "mobile:px-10",
    "mobile:py-10",
    "mobile:mb-4",
    // Tablet
    "tablet:pl-20",
    "tablet:pr-8",
    "tablet:py-2",
    "tablet:mb-0",
    // All
    "border-2",
    "border-[#04A9F4]",
    "rounded-3xl",
    "flex",
    "flex-row",
    "items-center",
    "justify-center",
    "relative",
    "mt-[32px]"
)

export const content = classNames(
    // Mobile
    "mobile:text-[25px]",
    // Tablet
    "tablet:text-[30px]",
    // All
)

export const clickHereButton = classNames(
    // Mobile
    // Tablet
    // All
    "bg-[#343F45]",
    "text-white",
    "py-2",
    "px-10",
    "ml-6",
    "rounded-xl",
    "text-[16px]"
)

export const mobileBtn = classNames(
    "bg-[#343F45]",
    "text-white",
    "py-2",
    "px-10",
    "ml-6",
    "rounded-xl",
    "text-[16px]",
    "absolute",
    "left-16",
    "-bottom-4"
)
